export const networkRequestsTableheaderText = {
  headerOne: "Name",
  headerTwo: "Email",
  headerThree: "Organisation",
  headerFour: "Phone number",
  headerFive: "Action status",
};
